import { apiRequest } from './apiWrapper'
import { v4 as uuidv4 } from 'uuid'
const requiestId = uuidv4()
export async function getTranslations({ language_code, appname }) {
    let url = `config/v1/translations/${language_code}?limit=4999`;
    if (appname) {
        url += `&appname=${appname}`;
    }
    const response = await apiRequest({
        method: "get",
        url,
        headers: {
            'x-version': '1.0.0',
            'x-appname': 'super-app',
            'x-request-id': requiestId
        },
    });

    return response;
}

export async function getLanguages() {
    let url = `config/v1/languages/?page=1&active=true`;

    const response = await apiRequest({
        method: "get",
        url,
        headers: {
            'x-version': '1.0.0',
            'x-appname': 'super-app',
            'x-request-id': requiestId
        },
    });

    return response;
}

export async function getconfiguration() {
    let url = `config/v1/configurations/?platform=web&appname=eros-create`;
    const userId = JSON.parse(localStorage.getItem('user'))?.user_id
    const response = await apiRequest({
        method: "get",
        url,
        headers: {
            'x-version': '1.0.0',
            'x-appname': 'super-app',
            'x-request-id': requiestId,
            'x-user-id': userId
        },
    });

    return response;
}